import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsrange',
	templateUrl:'./BSRangePluginCompPage.html',
	styles: [],
	styleUrls:['./BSRangePluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSRangePluginCompPage
{
	mdContent_859 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.range.BSRange;
\`\`\``;
	mdContent_860 = `\`\`\`java
BSRange()
\`\`\``;
	mdContent_861 = `\`\`\`java
BSRange&lt;?&gt; range = new BSRange&lt;&gt;();
range.setMin(0);
range.setMax(100);
range.setStep(5);
range.setValue(50);
\`\`\``;
}
